/**
 * @desc SSR을 통한 호출인지 CSR을 통한 호출인지 확인한다.
 */

export const checkIsBrowser = (): boolean => {
  return typeof XMLHttpRequest !== 'undefined';
};
export const checkIsServer = (): boolean => {
  return !checkIsBrowser();
};
